import { render } from "./RockFooter.vue?vue&type=template&id=77dfdcb2"
import script from "./RockFooter.vue?vue&type=script&lang=js"
export * from "./RockFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__